import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoriesSection from './components/CategoriesSection';
import InfoSections from './components/InfoSections';
import FAQSection from './components/FAQSection';
import ArticleLinks from './components/ArticleLinks';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://superbuyspread.casa';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': `${siteUrl}/#website`,
  url: siteUrl,
  name: 'Superbuy Spreadsheet',
  description: 'The ultimate product finding and shopping resource platform. Discover organized product finds, shopping guides, detailed comparisons, QC resources and expert tips.',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${siteUrl}/?q={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  '@id': `${siteUrl}/#organization`,
  name: 'Superbuy Spreadsheet',
  url: siteUrl,
  logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/67defc9f4dfae2c04004e8ea78b88107.png',
  sameAs: [
    'https://kaspreadsheet.com',
  ],
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoriesSection />
        <InfoSections />
        <ArticleLinks />
        <FAQSection />

        <section className="py-14 md:py-20 bg-background-100">
          <div className="w-full max-w-3xl mx-auto px-4 md:px-6 text-center">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
              Ready to Start Shopping Smarter?
            </h2>
            <p className="text-foreground-600 text-base mb-8 max-w-xl mx-auto">
              Join thousands of smart shoppers who use the Superbuy Spreadsheet approach to discover better products, compare options efficiently, and make confident purchasing decisions.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-primary-500 text-white text-base font-semibold whitespace-nowrap hover:bg-primary-600 transition-all duration-200"
              >
                Superbuy Sheet
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-foreground-900 text-white text-base font-semibold whitespace-nowrap hover:bg-foreground-800 transition-all duration-200"
              >
                Buy It Now
                <i className="ri-shopping-bag-line ml-2"></i>
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}